function delegate(el, evt, sel, handler) {
    el.addEventListener(evt, function (event) {
        var t = event.target;
        while (t && t !== this) {
            if (t.matches(sel)) {
                handler.call(t, event);
            }
            t = t.parentNode;
        }
    });
}

//HTTP Post Async
function httpPostAsync(theUrl, data, callback, error = function(e){ }) {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200)
            callback(xhr.responseText);
        if (xhr.readyState == 4 && xhr.status == 422)
            error(JSON.parse(xhr.responseText));
    }
    xhr.open("POST", theUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(data));
}

//HTTP Get Async
function httpGetAsync(theUrl, callback, error = function(e){ }) {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200)
            callback(xhr.responseText);
        if (xhr.readyState == 4 && xhr.status == 422)
            error(JSON.parse(xhr.responseText));
    }
    xhr.open("GET", theUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(null);
}

//Clear Radio Buttons
function clearButtons(id) {
    if (document.getElementById(id)) {
        var allOptions = document.getElementById(id).getElementsByTagName('li');
        for (var i = 0; i < allOptions.length; i++) {
            allOptions[i].classList.remove('selected');
        }
    }
}

//Toggle subscription button
function toggleSubscriptionMode(subscription, boxData, boxSize) {
    if(document.getElementById('Select_Subscription')) {
        document.getElementById('Select_Subscription').children[1].classList.remove('selected');
        document.getElementById('Select_Subscription').children[0].classList.add('selected');
        document.getElementById('Select_Subscription').classList.remove('disabled');
    }

    var monthlyli = document.getElementById('Monthly_Btn');
    var planTitle = document.getElementById('Plan_Title');
    var planDesc = document.getElementById('Plan_Description');
    if (subscription) {
        planTitle.innerHTML = "Choose your payment plan";
        planDesc.innerHTML = "Risk-free. Cancel anytime.";
        monthlyli.innerHTML = '<span class="button-left">Billed every month</span><span class="button-right"><span class="monthly-price">' + currencySymbol + boxData[boxSize].monthly.variants['regular'].price.toFixed(2) + '</span><br /></span>';
    } else {
        planTitle.innerHTML = "Choose your plan";
        planDesc.innerHTML = "Risk-free. Billed once. No monthly payments.";
        monthlyli.innerHTML = '<span class="button-left">One Box</span><span class="button-right"><span class="monthly-price">' + currencySymbol + boxData[boxSize].monthly.variants['regular'].price.toFixed(2) + '</span><br /></span>';
    }
}

//Populate Prepay Plans
function populatePrepayPlans(boxType, boxSize, gift = false, subscription = false, selectedIndex = null) {
    var prepayPlanElem = document.getElementById('Select_Plan');
    var prepayPlanBtns = document.getElementsByClassName('prepay-btn');
    while(prepayPlanBtns.length > 0){
        prepayPlanBtns[0].parentNode.removeChild(prepayPlanBtns[0]);
    }
    //prepayPlanElem.innerHTML = "";

    var boxData = {};
    switch (boxType) {
        case 'munch':
            if (gift) {
                boxData = munchGiftBoxItems;
            } else {
                boxData = munchBoxItems;
            }

            break;
        case 'korea':
            if (gift) {
                boxData = koreaGiftBoxItems2;
            } else {
                boxData = koreaBoxItems2;
            }
            break;

        case 'ramen':
            if (giftOneTime) {
                boxData = ramenGiftBoxItems;
            } else {
                boxData = ramenBoxItems;
            }
            break;

        case 'mexico':
            if (giftOneTime) {
                boxData = mexicoGiftBoxItems;
            } else {
                boxData = mexicoBoxItems;
            }
            break;
        default:
            boxData = munchBoxItems;
    }

    var boxDataCount = 0;
    var finalResult = "";
    for (key in boxData[boxSize].prepay) {
        var li = document.createElement("li");
        li.classList.add('prepay-btn');
        li.classList.add('prepay-plan');
        li.setAttribute('data-value', key);
        if (boxDataCount === selectedIndex && gift && selectedIndex !== null) {
            li.classList.add('selected');
            finalResult = key;
        }
        if (subscription || gift) {
            var monthKey = gift ? '' : 'Billed every';
            li.innerHTML = '<span class="button-left">' + monthKey + ' ' + key + ' months</span><span class="button-right"><span>' + currencySymbol + boxData[boxSize].prepay[key].variants['regular'].price.toFixed(2) + '</span><br />' + currencySymbol + (boxData[boxSize].prepay[key].variants['regular'].price / boxData[boxSize].prepay[key].months).toFixed(2) + '/box</span>';
        } else {
            var monthKey = 'boxes';
            li.innerHTML = '<span class="button-left">' + key + ' ' + monthKey + ' over ' + key + ' months</span><span class="button-right"><span>' + currencySymbol + boxData[boxSize].prepay[key].variants['regular'].price.toFixed(2) + '</span><br />' + currencySymbol + (boxData[boxSize].prepay[key].variants['regular'].price / boxData[boxSize].prepay[key].months).toFixed(2) + '/box</span>';
        }
        
        prepayPlanElem.appendChild(li);
        boxDataCount++;
    };

    return finalResult;
}

//Calculate Box Price
function calculateBoxPrice(boxData, boxSize, plan, prepayPlan, priortiy_processing, drink, addons, subscription = true) {
    //console.log("calculate box price");
    var finalPrice = 0;
    var pp = priortiy_processing ? 'priority_processing' : 'regular';
    if (subscription) {
        if (plan === 'prepay') {
            finalPrice += boxData[boxSize].prepay[prepayPlan.toString()].variants[pp].price;
        } else {
            finalPrice += boxData[boxSize].monthly.variants[pp].price;
        }
    } else {
        finalPrice += boxData['regular'].product.variants[pp].price;
    }
    if (drink) {
        if (plan === 'prepay') {
            finalPrice += drinkItems[prepayPlan.toString()].price;
        } else {
            finalPrice += drinkItems["1"].price;
        }
    }
    addons.forEach((item) => {
        if (item.quantity && item.quantity > 0) {
            finalPrice += upsellData[item.variantId].price * item.quantity;
        } else {
            finalPrice += upsellData[item.variantId].price;
        }

    });

    var totals = document.getElementsByClassName('total-price');
    for (var x = 0; x < totals.length; x++) {
        totals[x].innerHTML = currencySymbol + finalPrice.toFixed(2);
    }
}

function addToCart(items, gift, subscription, callback = function(){}) {
    var data = {
        items: []
    };

    // var giftMessage = {};
    // if (gift) {
    //     var gifter = document.getElementById('Gifter')?.value;
    //     var recipient = document.getElementById('Recipient')?.value;
    //     var customMessage = document.getElementById('Custom_Message')?.value;
    //     if (gifter !== null && gifter.trim() !== "") {
    //         giftMessage['from'] = gifter;
    //     }
    //     if (recipient !== null && recipient.trim() !== "") {
    //         giftMessage['to'] = recipient;
    //     }
    //     if (customMessage !== null && customMessage.trim() !== "") {
    //         giftMessage['message'] = customMessage;
    //     }
    // }
    items.forEach((item) => {
        if (item.type === "munch") {
            var props = {};
            if (item.prepay) {
                props['shipping_interval_frequency'] = 1;
                props['shipping_interval_unit_type'] = 'Months';
                props['charge_interval_frequency'] = parseInt(item.frequency);
                props['charge_interval_unit_type'] = 'Months';
                props['charge_on_day_of_month'] = 3;
                if (gift || !subscription) {
                    props['number_charges_until_expiration'] = 1;
                }
                data.items.push({
                    quantity: item.quantity,
                    id: item.variantId,
                    properties: props
                });

            } else {
                if (!gift) {
                    if (subscription) {
                        props['shipping_interval_frequency'] = 1;
                        props['shipping_interval_unit_type'] = 'Months';
                        props['charge_on_day_of_month'] = 3;
                    }
                }
                data.items.push({
                    "quantity": item.quantity,
                    "id": item.variantId,
                    "properties": props
                });


            }
        } else {

            if (item.type) {
                var props = {};
                data.items.push({
                    "quantity": item.quantity,
                    "id": item.variantId,
                    "type": "addon",
                    "properties": props
                });
            } else {
                data.items.push({
                    "quantity": item.quantity,
                    "id": item.variantId,
                    "type": "addon"
                });
            }
        }
    });
    if(Rebuy.SmartCart) {
        //Rebuy.SmartCart.skip_open = true;
    }
   
    httpPostAsync('/cart/add.js', data, (result) => {
        //window.location = document.getElementById('CartUrl').value;
        callback();
    });
}

function initSubscribe() {

    const orderForm = document.getElementById('OrderForm');

    //Check if order form exists
    if (orderForm) {

        //Get box type
        const boxType = orderForm.dataset.boxType;
        const gift = orderForm.dataset.gift == "true" ? true : false;
        const giftOneTime = orderForm.dataset.onetimeGift == "true" ? true : false;

        //Order Variables
        var boxSize = 'standard';
        var plan = 'monthly';
        var prepayPlan = 0;
        var priortiy_processing = false;
        var drink = false;
        var addons = [];
        var adding = false;
        var boxData = {};
        var boxSubscription = true;
        var subscription = gift ? false : true;

        switch (boxType) {
            case "munch":
                if (gift) {
                    boxData = munchGiftBoxItems;
                    boxSize = 'deluxe';
                    drink = false;
                    if(document.getElementById('Select_Drink')) {
                        document.getElementById('Select_Drink').children[0].classList.remove('selected');
                        document.getElementById('Select_Drink').children[1].classList.add('selected');
                        document.getElementById('Select_Drink').classList.add('disabled');
                        document.getElementById('drink_info').innerHTML = "An exotic drink is already included in each delivery.";
                    }
                } else {
                    boxData = munchBoxItems;
                }

                break;
            case 'korea':
                if (giftOneTime) {
                    boxData = koreaGiftBoxItems2;
                    boxSize = 'premium';
                } else {
                    boxData = koreaBoxItems2;
                }
                boxSubscription = false;
                break;
            case 'ramen':
                if (giftOneTime) {
                    boxData = ramenGiftBoxItems;
                } else {
                    boxData = ramenBoxItems;
                }
                boxSubscription = false;
                break;
            case 'mexico':
                if (giftOneTime) {
                    boxData = mexicoGiftBoxItems;
                } else {
                    boxData = mexicoBoxItems;
                }
                boxSubscription = false;
                break;
            default:
                boxData = munchBoxItems;
                boxSize = gift ? 'deluxe' : 'standard';
                break;
        }

        if (boxSubscription) {

            //Populate Box Sizes
            var boxSizeElm = document.getElementById('Select_BoxSize');
            var boxDataCounter = 0;
            for (var key in boxData) {
                var li = document.createElement("li");
                li.setAttribute('data-value', key);
                if (key == boxSize) {
                    li.classList.add('selected');
                    boxDataCounter++;
                }

                if (key == 'motherload') {
                    li.classList.add('double-line');
                }

                var drinkText = boxData[key].drinks === 1 ?  " + " + boxData[key].drinks + " Drink" : boxData[key].drinks > 1 ? " + " + boxData[key].drinks + " Drinks" : boxData[key].drinks === 0 ? " (Drink Optional)" : "(Drink Optional)";
                if (boxType == "korea" && boxData[key].drinks === 0) {
                    drinkText = "";
                }
                if (plan === "monthly" && !boxData[key].monthly) {
                    //li.classList.add('disabled');
                }
                var boxPrice = "";

                if (gift) {
                    if (boxData[key].monthly) {
                        boxPrice = boxData[key].monthly.variants['regular'].price.toFixed(2);
                    } else {
                        boxPrice = boxData[key].prepay[Object.keys(boxData[key].prepay)[0]].variants['regular'].price.toFixed(2);
                    }
                } else {
                    var finalIndex = Object.keys(boxData[key].prepay).length - 1;
                    var prepaidPrice = boxData[key].prepay[Object.keys(boxData[key].prepay)[finalIndex]].variants['regular'].price;
                    boxPrice = (prepaidPrice / 12).toFixed(2);
                }

                if (key == 'motherload') {                    
                    li.innerHTML = '<span class="button-left">' + boxData[key].snacks + ' Snacks' + drinkText + '<span class="extra-box-info">(15 Snacks + 1 Drink) X 4</span></span><span class="button-right">as low as<br />' + currencySymbol + boxPrice + '</span>';
                } else {
                    li.innerHTML = '<span class="button-left">' + boxData[key].snacks + ' Snacks' + drinkText + '</span><span class="button-right">as low as<br />' + currencySymbol + boxPrice + '</span>';
                }

                boxSizeElm.appendChild(li);
            }


            //Populate Plans
            var plansElm = document.getElementById('Select_Plan');
            var monthlyli = document.createElement("li");
            monthlyli.setAttribute('data-value', 'monthly');
            monthlyli.id = 'Monthly_Btn';
            monthlyli.classList.add('monthly-btn');
            monthlyli.classList.add('selected');
            if (gift) {
                singleboxvariant = boxType === "korea" ? "premium": "deluxe";
                monthlyli.innerHTML = '<span class="button-left">Just One Box</span><span class="button-right"></span><span class="button-right"><span class="monthly-price">' + currencySymbol + boxData[singleboxvariant].monthly.variants['regular'].price.toFixed(2) + '</span><br />' + currencySymbol + boxData[singleboxvariant].monthly.variants['regular'].price.toFixed(2) + '/box</span>';
            } else {
                if (subscription) {
                    monthlyli.innerHTML = '<span class="button-left">Billed every month</span><span class="button-right"><span class="monthly-price">' + currencySymbol + boxData[boxSize].monthly.variants['regular'].price.toFixed(2) + '</span><br /></span>';
                } else {
                    monthlyli.innerHTML = '<span class="button-left">One Box</span><span class="button-right"><span class="monthly-price">' + currencySymbol + boxData[boxSize].monthly.variants['regular'].price.toFixed(2) + '</span><br /></span>';
                }
            }

            plansElm.appendChild(monthlyli);


            // var prepayli = document.createElement("li");
            // prepayli.setAttribute('data-value', 'prepay');
            // prepayli.classList.add('prepay-btn');
            // if (gift) {
            //     prepayli.innerHTML = '<span class="button-left">Multi-Month & Save</span></span>';
            // } else {
            //     prepayli.innerHTML = '<span class="button-left">Prepay & Save</span></span>';
            // }

            // plansElm.appendChild(prepayli);

            prepayPlan = populatePrepayPlans(boxType, boxSize, gift, subscription);

        }

        delegate(document, "click", ".radio-group", function (event) {
            //console.log('click!');
            event.preventDefault();
            var targetElement = event.target || event.srcElement;

            if (targetElement.classList.contains('button-left') || targetElement.classList.contains('button-right') || targetElement.classList.contains('extra-box-info')) {
                if (targetElement.classList.contains('extra-box-info')) {
                    targetElement = targetElement.parentElement.parentElement;
                } else {
                    targetElement = targetElement.parentElement;
                }
                
            }

            if (targetElement.classList.contains('disabled') || targetElement.parentElement.classList.contains('disabled')) {
                return;
            }

            if (targetElement.classList.contains('prepay-btn')) {
                // document.getElementById('Select_Prepay_Plan').classList.remove('hide');
                //plan = 'prepay';
                if (gift) {
                    // var boxSizes = document.querySelectorAll('#Select_BoxSize li');
                    // for (var x = 0; x < boxSizes.length; x++) {
                    //     boxSizes[x].classList.remove('disabled');
                    //     boxSizes[x].classList.remove('selected');
                    //     if (x === 0) {
                    //         boxSizes[x].classList.add('selected');
                    //         boxSize = "standard";
                    //     }
                    // }
                    // var giftPackages = document.getElementsByClassName('gift-package');
                    // for (var x = 0; x < giftPackages.length; x++) {
                    //     giftPackages[x].classList.remove('hide');
                    // }

                }
                //prepayPlan = populatePrepayPlans(boxType, boxSize, 0, gift);


            }

            if (targetElement.classList.contains('monthly-btn')) {
                //document.getElementById('Select_Prepay_Plan').classList.add('hide');
                if (gift) {
                    // var boxSizes = document.querySelectorAll('#Select_BoxSize li');
                    // for (var x = 0; x < boxSizes.length; x++) {
                    //     boxSizes[x].classList.remove('selected');
                    //     if (x < 2 && boxType === "munch") {
                    //         //boxSizes[x].classList.add('disabled');
                    //     }
                    //     if (x === 2 && boxType === "munch") {
                    //         //boxSizes[x].classList.add('selected');
                    //         boxSize = "deluxe";
                    //     }

                    //     if (x < 1 && boxType === "korea") {
                    //         //boxSizes[x].classList.add('disabled');
                    //     }
                    //     if (x === 1 && boxType === "korea") {
                    //         //boxSizes[x].classList.add('selected');
                    //         boxSize = "premium";
                    //     }
                    // }
                    // var giftPackages = document.getElementsByClassName('gift-package');
                    // for (var x = 0; x < giftPackages.length; x++) {
                    //     giftPackages[x].classList.add('hide');
                    // }
                }
                plan = 'monthly';
            }

            if (targetElement.classList.contains('prepay-plan')) {
                prepayPlan = targetElement.dataset.value;
                plan = 'prepay';
            }

            if (targetElement.parentElement.classList.contains('box-size')) {
                boxSize = targetElement.dataset.value;
                prepayPlan = 0;
                if (!gift) {
                    //document.getElementById('Select_Prepay_Plan').classList.add('hide');
                    document.getElementsByClassName('monthly-btn')[0].classList.add('selected');
                    document.getElementsByClassName('prepay-btn')[0].classList.remove('selected');
                    document.getElementsByClassName('monthly-price')[0].innerHTML = currencySymbol + boxData[boxSize].monthly.variants['regular'].price.toFixed(2);
                    plan = 'monthly';
                    prepayPlan = populatePrepayPlans(boxType, boxSize, gift, subscription, 0);
                } else {
                    if(plan == 'monthly') {
                        if(boxData[boxSize].monthly) {
                            document.getElementsByClassName('monthly-btn')[0].classList.remove('disabled');
                            document.getElementsByClassName('monthly-price')[0].innerHTML = currencySymbol + boxData[boxSize].monthly.variants['regular'].price.toFixed(2);
                            populatePrepayPlans(boxType, boxSize, gift, subscription);
                            prepayPlan = 0;
                        } else {
                            plan = 'prepay';
                            document.getElementsByClassName('monthly-btn')[0].classList.add('disabled');
                            prepayPlan = populatePrepayPlans(boxType, boxSize, gift, subscription, 0);                        }
                        
                    } else {
                        if(boxData[boxSize].monthly) {
                            plan = 'monthly';
                            document.getElementsByClassName('monthly-btn')[0].classList.remove('disabled');
                            document.getElementsByClassName('monthly-btn')[0].classList.add('selected');
                            document.getElementsByClassName('monthly-price')[0].innerHTML = currencySymbol + boxData[boxSize].monthly.variants['regular'].price.toFixed(2);
                            populatePrepayPlans(boxType, boxSize, gift, subscription);
                            prepayPlan = 0;
                        } else {
                            document.getElementsByClassName('monthly-btn')[0].classList.add('disabled');
                            prepayPlan = populatePrepayPlans(boxType, boxSize, gift, subscription, 0);
                        }
                    }                   
                }
                
                switch(boxSize) {
                    case 'standard':
                        drink = false;
                        if(document.getElementById('Select_Drink')) {
                            document.getElementById('Select_Drink').children[1].classList.remove('selected');
                            document.getElementById('Select_Drink').children[0].classList.add('selected');
                            document.getElementById('Select_Drink').classList.remove('disabled');
                            document.getElementById('drink_info').innerHTML = "Add an exotic drink to each box for an additional $6.00/delivery";
                        }
                        if (!gift) {
                            subscription = true;
                            toggleSubscriptionMode(subscription, boxData, boxSize);
                        }                        
                        break;
                    case 'premium':
                        drink = false;
                        if(document.getElementById('Select_Drink')) {
                            document.getElementById('Select_Drink').children[1].classList.remove('selected');
                            document.getElementById('Select_Drink').children[0].classList.add('selected');
                            document.getElementById('Select_Drink').classList.remove('disabled');
                            document.getElementById('drink_info').innerHTML = "Add an exotic drink to each box for an additional $6.00/delivery";
                        }
                        if (!gift) {
                            subscription = true;
                            toggleSubscriptionMode(subscription, boxData, boxSize);
                        }
                        break;
                    case 'deluxe':
                        drink = false;
                        if(document.getElementById('Select_Drink')) {
                            document.getElementById('Select_Drink').children[0].classList.remove('selected');
                            document.getElementById('Select_Drink').children[1].classList.add('selected');
                            document.getElementById('Select_Drink').classList.add('disabled');
                            document.getElementById('drink_info').innerHTML = "An exotic drink is already included in each delivery.";
                        }
                        if (!gift) {
                            subscription = true;
                            toggleSubscriptionMode(subscription, boxData, boxSize);
                        }
                        break;
                    case 'motherload':
                        drink = false;
                        if(document.getElementById('Select_Drink')) {
                            document.getElementById('Select_Drink').children[0].classList.remove('selected');
                            document.getElementById('Select_Drink').children[1].classList.add('selected');
                            document.getElementById('Select_Drink').classList.add('disabled');
                            document.getElementById('drink_info').innerHTML = "Four exotic drinks are already included in each delivery.";
                        }
                        if (!gift) {
                            subscription = true;
                            toggleSubscriptionMode(subscription, boxData, boxSize);
                        }
                        break;
                }
            }

            if (targetElement.parentElement.classList.contains('choose-subscription')) {
                subscription = targetElement.dataset.value === "yes" ? true : false;
                toggleSubscriptionMode(subscription, boxData, boxSize);
                
                populatePrepayPlans(boxType, boxSize, gift, subscription);
            }

            if (targetElement.parentElement.classList.contains('priority-processing')) {
                priortiy_processing = targetElement.dataset.value === "yes" ? true : false;
            }

            if (targetElement.parentElement.classList.contains('add-drink')) {
                drink = targetElement.dataset.value === "yes" ? true : false;
            }

            clearButtons(targetElement.parentElement.id);
            targetElement.classList.add('selected');

            calculateBoxPrice(boxData, boxSize, plan, prepayPlan, priortiy_processing, drink, addons, boxSubscription);
        });

        //Update QTY Function
        var updateQtyFunc = function (event) {
            event.preventDefault();
            var targetElement = event.target || event.srcElement;
            const addon = addons.find(el => el.variantId == targetElement.dataset.value);
            const newQty = parseInt(targetElement.value);

            if (newQty <= 0) {
                targetElement.classList.add('field--with-error');
            } else {
                targetElement.classList.remove('field--with-error');
                if (addon) {
                    targetElement.classList.remove('field--with-error');
                    addon.quantity = newQty;
                    addons.splice(addons.indexOf(addon), 1);
                    addons.push(addon);
                }
            }
            calculateBoxPrice(boxData, boxSize, plan, prepayPlan, priortiy_processing, drink, addons, boxSubscription);
        }

        //QTY Event Handler
        const qtyBtns = document.getElementsByClassName('qty');
        for (var i = 0; i < qtyBtns.length; i++) {
            qtyBtns[i].addEventListener('change', updateQtyFunc, false);
        }

        //Add On Click Function
        var clickAddOnFunc = function (event) {
            event.preventDefault();
            var targetElement = event.target || event.srcElement;
            const addon = addons.find(el => el.variantId == targetElement.dataset.value);
            if (addon) {
                addons.splice(addons.indexOf(addon), 1);
                targetElement.classList.remove('selected');
                targetElement.innerHTML = "Add";
            } else {
                targetElement.innerHTML = "Remove";
                targetElement.classList.add('selected');
                addons.push({
                    variantId: targetElement.dataset.value,
                    quantity: targetElement.previousElementSibling.value
                });
            }

            calculateBoxPrice(boxData, boxSize, plan, prepayPlan, priortiy_processing, drink, addons, boxSubscription);
        };

        //Add On Event Handler
        const addOnBtns = document.getElementsByClassName('add-on');
        for (var i = 0; i < addOnBtns.length; i++) {
            const btns = addOnBtns[i].getElementsByClassName('button');
            for (var j = 0; j < btns.length; j++) {
                btns[j].addEventListener('click', clickAddOnFunc, false);
            }
        }

        //Add to Cart Click Function        
        var submitFunc = function (event) {
            event.preventDefault();
            var targetElement = event.target || event.srcElement;
            if (!adding) {
                adding = true;
                targetElement.innerHTML = "Adding...";
                var pp = priortiy_processing ? 'priority_processing' : 'regular';
                var items = [];
                var prepay = plan === "monthly" ? false : true;

                if (boxSubscription) {
                    items.push({
                        quantity: 1,
                        variantId: prepay ? boxData[boxSize].prepay[prepayPlan].variants[pp].id : boxData[boxSize].monthly.variants[pp].id,
                        type: boxType,
                        frequency: prepayPlan,
                        prepay: prepay
                    });
                    if (drink) {
                        items.push ({
                            quantity: 1,
                            variantId: prepay ? drinkItems[prepayPlan].id : drinkItems["1"].id,
                            type: boxType,
                            frequency: prepayPlan,
                            prepay: prepay
                        });
                    }
                } else {
                    items.push({
                        quantity: 1,
                        variantId: boxData['regular'].product.variants[pp].id,
                        type: boxType
                    });
                    if (drink) {
                        items.push ({
                            quantity: 1,
                            variantId: drinkItems["1"].id,
                            type: boxType,
                        });
                    }
                }

                addons.forEach((addon) => {
                    items.push({
                        quantity: addon.quantity,
                        variantId: addon.variantId
                    })
                });

                addToCart(items, gift || giftOneTime, subscription, function(){
                    targetElement.innerHTML = "Add to Cart";
                    adding = false;
                });
            }
        };

        //Add to Cart Event Handler
        const submitBtns = document.getElementsByClassName('add-to-cart');
        for (var i = 0; i < submitBtns.length; i++) {
            submitBtns[i].addEventListener('click', submitFunc, false);
        }

        calculateBoxPrice(boxData, boxSize, plan, prepayPlan, priortiy_processing, drink, addons, boxSubscription);
    }
}

initSubscribe();
